import React from 'react';
import { kgDivision } from '../../../Store';

const BidGroup = ({ bidGroup }) => {
    
    //===============================================
    // Css
    //===============================================
    const container = {
        backgroundColor:'#fff',border : '1px solid #ababab',borderRadius : '10px', padding : '10px', width: '100%', marginBottom: '10px'
    }
    const bidStatus1 = {
        padding:'7px 10px 0px 10px', margin:'5px', backgroundColor:'red',color:'#fff', fontSize:'16px', fontWeight: 'bold', width:'100px'
    }
    const bidStatus8 = {
        padding:'7px 10px 0px 10px', margin:'5px', backgroundColor:'#ffa500',color:'#fff', fontSize:'16px', fontWeight: 'bold', width:'100px'
    }
    const bidStatus9 = {
        padding:'7px 10px 0px 10px', margin:'5px', backgroundColor:'#006400',color:'#fff', fontSize:'16px', fontWeight: 'bold', width:'100px'
    }
    const bidStatuscBidDone = {
        padding:'7px 10px 0px 10px', margin:'5px', backgroundColor:'#0007b9',color:'#fff', fontSize:'16px', fontWeight: 'bold', width:'100px'
    }
    const bidTime = {
        padding:'5px', margin:'5px', color:'#305496', fontSize:'20px', fontWeight: 'bold'
    }
    const gyoshu = {
        fontSize:'20px', fontWeight:'bold', textDecoration:'underline'
    }
    const bidDetail = {
        fontSize:'20px', fontWeight:'normal',
    }
    return (
        
            <div style={{borderRadius : '10px', width: '100%'}}>
                <div style={container}>
                    <div style={{display : 'flex',}}>
                        {
                          bidGroup.groupStatus == 8 ? (
                            <div style={bidStatus8}>開票中</div>
                          ) : bidGroup.groupStatusText == '確定売り' ? (
                            <div style={bidStatuscBidDone}>確定売り</div>
                          ) : bidGroup.groupStatus == 9 ? (
                            <div style={bidStatus9}>入札終了</div>
                          ) : bidGroup.isBidding == 1 ? (
                            <div style={bidStatuscBidDone}>入札済み</div>
                          ) : bidGroup.groupStatus == 1 ? (
                            <div style={bidStatus1}>入札中</div>
                          ) : null
                        }
                        <div style={bidTime}>
                            <span>{bidGroup.startTime}</span>
                            ～
                            <span>{bidGroup.endTime}</span>
                        </div>
                    </div>
                    <div style={gyoshu}>{bidGroup.bidName}</div>
                    <div style={gyoshu}>
                    {
                        bidGroup.kgKubun ?
                        <>{bidGroup.kgSuryo}Kg</>
                        :
                        <>{bidGroup.suryo}箱</>
                    } / {bidGroup.danbe}</div>
                </div>
            </div>
        
    )
  }
  
  export default BidGroup;